export default function HotelsMapController(
    $scope,
    $rootScope,
    $stateParams,
    $state,
    mapsFactory,
    hotelsFactory,
    hotelEvents,
    hotelsAPI,
    baseEvents,
    userService,
    hotelSearchResults,
    googleMapsService
) {
    'ngInject';

    const formData = hotelsFactory.getFormData();
    const regionalSettings = userService && userService.getRegionalSettings();

    const vm = this;
    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        $scope.hotels = hotelSearchResults.hotels;
        subscribe();
        initMarkers();
        initMap();
    }

    $scope.showMap = false;
    $scope.MarkersWithLabel = [];
    $scope.hotelSearchResults = hotelSearchResults;
    const markerTemplate = '<span class="content">&nbsp;</span>';
    const addressTemplate = _.template(
        ['<span class="content">',
            '<span class="name">{{name}}</span>',
            '<span class="address">{{address}}</span>',
            '</span>'].join(''));
    const priceTemplate = _.template('<span class="content">' + (regionalSettings && regionalSettings.currencySign) + '{{price}}</span>');

    let tempMarker = null;

    $scope.markersEvents = {
        click: clickHandler,
        mouseover: mouseOverHandler,
        mouseout: mouseOutHandler,
    };

    function subscribe() {
        $rootScope.$broadcast(hotelEvents.HOTELS_UPDATE_MAP_MARKERS);
        $scope.$on(baseEvents.TRIGGER_MAP_VISIBILITY, function() {
            $scope.showMap = !$scope.showMap;
        });
        $scope.$on(baseEvents.MAP_SHOW_HIDE_RATES, showHideRates);
    }

    function initMap() {
        const maps = googleMapsService.getGoogleMaps();
        Object.assign($scope, mapsFactory.getMapInitOptions(maps));
    }

    function showHideRates() {
        const markers = $scope.markersControl.getGMarkers();
        const checkClass = markers[0].labelClass;

        markers.forEach(function(marker) {
            if (marker.get('labelClass') === 'icon_marker_center') {
                return;
            }

            if (['icon_marker', 'icon_address'].indexOf(checkClass) !== -1) {
                marker.set('labelClass', 'price_marker');
                marker.set('labelContent', priceTemplate(marker));
            } else {
                marker.set('labelClass', 'icon_marker');
                marker.set('labelContent', markerTemplate);
            }
            marker.set('zIndex', 3);
        });
    }

    function mouseOverHandler(targetMmarker) { // eslint-disable-line
        if (!targetMmarker || tempMarker === targetMmarker.key) {
            return;
        }
        tempMarker = targetMmarker.key;
        const checkZIndex = targetMmarker.zIndex;
        if (checkZIndex !== 5) {
            targetMmarker.set('zIndex', 4);
        }

        const checkLabel = targetMmarker.labelClass;

        if (checkLabel === 'icon_marker') {
            $scope.markersControl.getGMarkers().forEach(function(marker) {
                if (marker.labelClass === 'icon_address') {
                    marker.set('labelClass', 'icon_marker');
                    marker.set('labelContent', markerTemplate);
                }
            });
            targetMmarker.set('labelClass', 'icon_address');
            targetMmarker.set('labelContent', addressTemplate(targetMmarker));
        } else if (checkLabel === 'icon_address') {
            targetMmarker.set('labelClass', 'icon_marker');
            targetMmarker.set('labelContent', markerTemplate);
        }

        if (checkLabel === 'price_marker') {
            $scope.markersControl.getGMarkers().forEach(function(marker) {
                if (marker.labelClass === 'address_marker') {
                    marker.set('labelClass', 'price_marker');
                    marker.set('labelContent', priceTemplate(marker));
                }
            });
            targetMmarker.set('labelClass', 'address_marker');
            targetMmarker.set('labelContent', addressTemplate(targetMmarker));
        } else if (checkLabel === 'address_marker') {
            targetMmarker.set('labelClass', 'price_marker');
            targetMmarker.set('labelContent', priceTemplate(targetMmarker));
        }
    }

    function clickHandler(marker) {
        const state = $state.current.name.split('.')[1];
        $rootScope.$broadcast(state + '-marker-click', marker);
    }

    function mouseOutHandler() {
        $scope.markersControl.getGMarkers().forEach(function(marker) {
            if (marker.labelClass === 'icon_address') {
                marker.set('labelClass', 'icon_marker');
                marker.set('labelContent', markerTemplate);
            }
        });
        tempMarker = null;
    }

    function initMarkers() {
        $scope.$watch('hotelSearchResults.Markers', (newValue) => {
            $scope.MarkersWithLabel = mapsFactory.composeMarkers(newValue);
        });

        const {latitude, longitude} = formData;
        $scope.cityCenterMarker = mapsFactory.createCityCenterMarker(latitude, longitude);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/controllers/hotels-map-controller.js